import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { useGlobal } from '../global/GlobalContext';
import { useWishlistAddToCart } from '../hooks/useWishlistAddToCart';
import ProductCard from './ProductCard';
import SizeSelectionPopup from './SizeSelectionPopup';
import DistributorQuantityPopup from './DistributorQuantityPopup';

const YouAlsoLike = ({ currentProduct }) => {
  const { token, wishlist, setWishlist, products } = useGlobal();
  const {
    addingId,
    isSizePopupOpen,
    sizeOptions,
    selectedVariation,
    setSelectedVariation,
    closeSizePopup,
    confirmSize,
    isQtyPopupOpen,
    selectedQuantity,
    setSelectedQuantity,
    popupQuantities,
    getItemPackQty,
    closeQtyPopup,
    confirmQuantity,
    handleAddToCartClick,
    currentItem,
  } = useWishlistAddToCart({ navigateOnSuccess: false });

  if (!currentProduct || !Array.isArray(products)) return null;

  // "Similar" is a shared category — matching by an exact product_tag string
  // (the old logic) is a weak signal, since a marketing tag like "New" could
  // group together completely unrelated products. Category overlap is kept
  // as a secondary signal so a genuinely-tagged match still surfaces even
  // without a shared category.
  const currentCategoryIds = new Set((currentProduct.product_categories || []).map((c) => c.id));
  const tag = currentProduct.product_tag && currentProduct.product_tag !== 'null' ? currentProduct.product_tag : null;

  const likedProducts = products
    .filter((p) => {
      if (p.id === currentProduct.id) return false;
      const sharesCategory = p.product_categories?.some((c) => currentCategoryIds.has(c.id));
      const sharesTag = tag && p.product_tag === tag;
      return sharesCategory || sharesTag;
    })
    .slice(0, 12);

  if (likedProducts.length === 0) return null;

  return (
    <div className="pt-3">
      <h2 className="text-lg font-bold text-gray-900 mb-4">You May Also Like</h2>

      <Swiper
        navigation
        loop={false}
        breakpoints={{
          360: { slidesPerView: 2.1 },
          640: { slidesPerView: 3.2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
        spaceBetween={16}
        modules={[Navigation]}
        className="mySwiper !pb-2"
      >
        {likedProducts.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard
              product={product}
              wishlist={wishlist}
              setWishlist={setWishlist}
              token={token}
              onQuickAdd={handleAddToCartClick}
              addingId={addingId}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <SizeSelectionPopup
        open={isSizePopupOpen}
        sizeOptions={sizeOptions}
        selectedVariation={selectedVariation}
        onSelect={setSelectedVariation}
        onClose={closeSizePopup}
        onConfirm={confirmSize}
      />

      <DistributorQuantityPopup
        open={isQtyPopupOpen}
        packQty={getItemPackQty(currentItem, selectedVariation)}
        quantities={popupQuantities}
        selectedQuantity={selectedQuantity}
        onSelect={setSelectedQuantity}
        onClose={closeQtyPopup}
        onConfirm={confirmQuantity}
      />
    </div>
  );
};

export default YouAlsoLike;
